export const imageMimeTypes: Record<string, string> = {
  apng: 'image/apng',
  bmp: 'image/bmp',
  gif: 'image/gif',
  ico: 'image/x-icon',
  jpeg: 'image/jpeg',
  jpg: 'image/jpeg',
  jfif: 'image/jpeg',
  pjpeg: 'image/jpeg',
  pfp: 'image/pjp',
  png: 'image/png',
  svg: 'image/svg+xml',
  tiff: 'image/tiff',
  tif: 'image/tiff',
  webp: 'image/webp',
};

/**
 * Well... is the file an image?
 * @param file
 * @returns
 */
export const isImage = (file: File) => Object.values(imageMimeTypes).includes(file.type);
